import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Logo from "../assets/logo.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    if (!email) {
      toast.error("Please enter your email.");
      setLoading(false);
      return;
    }
    
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("Password reset email sent! Check your inbox.");
    } catch (err) {
      toast.error(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-main">
      <div className="login-left">
        <img src={Logo} alt="Background" />
      </div>
      <div className="login-right">
        <div className="login-right-container">
          <div className="login-logo">
            <a href="/">
              <img src={Logo} alt="Logo" />
            </a>
          </div>
          <div className="login-center">
            <h3 className="login-text">Reset Your Password</h3>
            <span>Enter your email to receive a password reset link</span>
            <form onSubmit={handleResetPassword}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className="login-center-buttons">
                <button type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Send Reset Email"}
                </button>
              </div>
            </form>
          </div>
          <p className="login-bottom-p">
            Remembered your password? <a href="/">Log In</a>
          </p>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar />
    </div>
  );
};

export default ForgotPassword;
